import { createContext, useContext, useReducer  } from 'react'

const DataContext = createContext()

const useData = () => {
    const context = useContext(DataContext)

    if (context === undefined) throw new Error('useData must be used within a DataProvider')

    return context
}

const DataProvider = ({ children }) => {
    const reducer = (state, { name, payload }) => {
        return { ...state, [name]: payload }
    }

    const [$state, dispatch] = useReducer(reducer, {})

    const save = (name, payload) => dispatch({ name, payload })

    return (
        <DataContext.Provider value={{ $state, save }}>
            {children}
        </DataContext.Provider>
    )
}

export { useData, DataProvider }